export class DropdownToggle {
  constructor() {
    return {
      link: function(scope, element, attr) {
        var getTarget = () => angular.element(attr.dropdownToggle);

        var close = () => {
          element[0].classList.remove('expanded');
          getTarget().css({ top: '', left: '' }).removeClass('open f-open-dropdown');
          scope.configMenuStatus = false;
        };

        var open = () => {
          var target = getTarget();
          var rect = element[0].getBoundingClientRect();
          var offsetParent = target[0].offsetParent || document.body;
          var parentRect = offsetParent.getBoundingClientRect();
          target.css({ top: (rect.bottom - parentRect.top) + 'px', left: (rect.left - parentRect.left) + 'px' });
          element[0].classList.add('expanded');
          target.addClass('open f-open-dropdown');
          scope.configMenuStatus = true;
          target.find('a').off('click.ddt').on('click.ddt', close);
        };

        element.on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var wasOpen = scope.configMenuStatus;
          close();
          if (!wasOpen) { open(); }
        });

        angular.element(document).on('click', function(e) {
          var target = getTarget();
          if (scope.configMenuStatus && !element[0].contains(e.target) && !target[0].contains(e.target)) {
            close();
          }
        });
      }
    };
  }
}
